import { useState, useEffect } from "react";
import debounce from "lodash.debounce";

const debouncedGetPlacePredictions = debounce(getPlacePredictions, 500);

const useAddressSuggestions = (term, state, sessionToken) => {
  const [suggestions, setSuggestions] = useState([]);
  const [error, setError] = useState(null);

  const validTerm = term && term.trim && term.trim();

  useEffect(
    () => {
      if (!hasGooglePlaces()) {
        setError(Error("Google Places Not Found"));
      } else if (sessionToken && validTerm && validTerm.length) {
        debouncedGetPlacePredictions(
          validTerm,
          state,
          sessionToken,
          result => {
            setSuggestions(result);
            setError(null);
          },
          err => {
            setSuggestions([]);
            setError(err);
          }
        );
      } else {
        setSuggestions([]);
        setError(null);
      }
    },
    [validTerm, state, sessionToken]
  );

  return [suggestions, error];
};

function hasGooglePlaces() {
  return window.google && window.google.maps && window.google.maps.places;
}

function getPlacePredictions(input, state, sessionToken, onSuccess, onError) {
  const autocompleteService = new window.google.maps.places.AutocompleteService();
  const stateNameString = state || "";
  autocompleteService.getPlacePredictions(
    {
      input: `${input} ${stateNameString}`,
      sessionToken,
      componentRestrictions: { country: "us" }
    },
    (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        onSuccess(
          predictions.map(x => ({
            placeId: x.place_id,
            text: x.description
          }))
        );
      } else if (
        status === window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS
      ) {
        onSuccess([]);
      } else {
        onError(Error(status));
      }
    }
  );
}

export default useAddressSuggestions;
